<template>
  <div class="today-timing-wrap">
    <div class="timing-title-wrap">
      <el-row type="flex" class="timing-title">
        <el-col :span="3">
          <img class="edit_icon" src="./img/CombinedShape.png">
        </el-col>
        <el-col :span="8">
          <div class="title-left"><span>今日计时</span></div>
        </el-col>
      </el-row>
    </div>
    <!--  列表 -->
     <div class="timing-list-wrap" v-loading="loading">
      <div class="" v-for="(item, index) in memberLists" :key="index">
        <el-row
          class="timing-item"
          type="flex"
          align="middle"
          style="cursor: pointer;"
          @click.native="checkDetails(item, index)">
          <el-col :span="3">
            <div class="image-wrap" v-if="item.userPic">
              <el-image :src="item.userPic"></el-image>
            </div>
            <div class="image-wrap" v-if="!item.userPic">
              {{item.userName.substr(0, 1)}}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="memeber-name" :title="item.userName">
              {{item.userName}}
            </div>
          </el-col>
          <el-col :span="16">
            <div class="member-record">
              <span>{{item.allTimingSum}}</span>h/<span>{{item.totalCount}}</span>条记录
              <i class="el-icon-caret-top" v-if='item.status'></i>
              <i class="el-icon-caret-bottom" v-if='!item.status'></i>
            </div>
        </el-col>
        </el-row>
        <!-- 详情 -->
        <div v-loading="item.detailsLoading">
          <div v-if='item.status && item.timeDetailslist.length > 0' class="details-wrap">
            <el-row
              class="timing-details"
              type="flex"
              v-for="(childItem, i) in item.timeDetailslist" :key="i"
              justify="space-between">
              <el-col :span="18">
                <div
                  class="task-introduce"
                  :class="{'no-description': !childItem.highLightName}"
                  :title="childItem.highLightName || '未录入工作描述'"
                >
                  {{childItem.highLightName || '未录入工作描述'}}
                </div>
              </el-col>
              <el-col :span="6">
                <div class="task-time">{{childItem.useTime}}</div>
              </el-col>
            </el-row>
          </div>
          <div class="no-details" v-if="item.status && item.timeDetailslist.length == 0">今日无计时</div>
        </div>
      </div>
      <!-- 查看更多 -->
      <div class="more-title" style="cursor: pointer;" v-if="showMore" @click="checkMoreLists()">查看更多</div>
      <div class="more-title" v-if="!showMore">没有更多内容</div>
     </div>
  </div>
</template>

<script>

import dynamicService from '../../service/dynamic'
import moment from 'moment'

export default {
  name: 'todayTiming',
  props: {},
  data () {
    return {
      showMore: true,
      loading: false,
      detailsLoading: false,
      memberLists: [],
      timeValue: [new Date(), new Date()],
      params: {
        pageIndex: 1,
        pageSize: -1,
        startTime: moment().format('YYYY-MM-DD'),
        endTime: moment().format('YYYY-MM-DD'),
        // startTime: '2019-01-01',
        // endTime: '2019-09-31',
        createUserId: localStorage.userid
      },
      listParams: {
        pageIndex: 1,
        pageSize: 10,
        startTime: moment().format('YYYY-MM-DD'),
        endTime: moment().format('YYYY-MM-DD')
        // startTime: '2019-01-01',
        // endTime: '2019-09-31'
      },
      timeDetailslist: []
    }
  },
  beforeMount () {

  },
  created () {
    this.getTimingMemberLists()
  },
  methods: {
    checkDetails (item, index) {
      item.status = !item.status
      if (!item.status) { return }
      this.getTimingDetailsLists(index, item)
    },
    // 查看更多
    checkMoreLists () {
      this.$analysis.track('查看更多_今日计时/工作台模块')
      this.listParams.pageIndex += 1
      this.getTimingMemberLists()
    },
    // 获取该账号下可以查看其它成员计时的列表
    getTimingMemberLists () {
      let _this = this
      _this.loading = true
      dynamicService.getTimingMemberLists(this.listParams).then(response => {
        if (response.isSuccess) {
          response.data.timingStatisticsVos.forEach(function (item) {
            _this.$set(item, 'status', false)
            _this.$set(item, 'detailsLoading', false)
            _this.$set(item, 'timeDetailslist', [])
            item['allTimingSum'] = _this.changeMsToHm(item['allTimingSum'])
          })
          _this.loading = false
          _this.memberLists = _this.memberLists.concat(response.data.timingStatisticsVos || [])
          _this.showMore = response.data.totalCount > _this.memberLists.length
        } else {
          this.$message(response.resultMsg)
          _this.loading = false
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    // 获取每个成员计时详情的列表
    getTimingDetailsLists (index, items) {
      this.$analysis.track('查看成员计时_今日计时/工作台模块')
      let _this = this
      items.detailsLoading = true
      _this.params.createUserId = items.userId
      _this.timeDetailslist = []
      dynamicService.getTimingDetailsLists(this.params).then(data => {
        if (data.succeed) {
          _this.timeDetailslist = data.result.items || []
          _this.timeDetailslist.forEach(function (item) {
            item['useTime'] = _this.changeMsToHm(item['useTime'])
          })
          items.detailsLoading = false
          // 给详情赋值
          items['timeDetailslist'] = _this.timeDetailslist
        } else {
          items.detailsLoading = false
        }
      })
    },
    // 对时间处理
    changeMsToHm: function (params) {
      function turnTo (num) {
        return num < 10 ? '0' + num : num
      }
      var hour = Math.floor(params / 3600000)
      var min = Math.floor(params % 3600000 / 60000)
      var data = params ? turnTo(hour) + ':' + turnTo(min) + "'" : "00:00'"
      return data
    }
  }
}
</script>

<style lang="stylus">
  .today-timing-wrap{
    width: 280px;
    box-sizing: border-box;
    padding: 0 24px;
    background: #ffffff;
  }
  .timing-title-wrap{

  }
  .timing-title .title-left span{
    font-size: 14px;
    color: #ED6C00;
  }
  .timing-title{
    padding: 26px 0 6px;
  }
  .edit_icon{
    width: 13px;
    height: 15px;
    padding-top: 2px;
  }
  .timing-list-wrap{
    overflow: auto;
    max-height: 520px;
  }
  .timing-item{
    padding: 8px 0;
  }
  .image-wrap{
    width: 32px;
    height: 32px;
    border-radius: 32px;
    overflow: hidden;
    background: #fdba78;
    font-size: 18px;
    text-align: center;
    line-height: 32px;
    color: #fff;
  }
  .memeber-name{
    width: 54px;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    font-size: 14px;
    color: #212121;
    padding-left: 8px;
  }
  .member-record{
    text-align: right;
    color: #8590A6;
    font-size: 14px;
  }
  .member-record span{
    // font-size: 16px;
  }
  .details-wrap{
    padding: 8px 0;
    background: #F8F8F8;
  }
  .timing-details{
    background: #F8F8F8;
    height: 25px;
    line-height: 25px;
    font-size: 12px;
    padding: 0 14px;
  }
  .task-introduce{
    color: #000000;
    font-size: 12px;
    width: 150px;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
  }
  .no-description{
    color: #a9a9a9 !important;
  }
  .task-time{
    color: #8590A6;
    font-size: 12px;
    text-align: right;
  }
  .no-details{
    background: #F8F8F8;
    text-align: center;
    padding: 5px 0;
    color: #8590a6;
  }
  .more-title{
    text-align: center;
    padding: 5px 0 14px;
    color: #8590a6;
  }
</style>
